import { Component, Input, OnInit, ElementRef, Renderer2 } from '@angular/core';
import parsePhoneNumber, { PhoneNumber } from 'libphonenumber-js';

@Component({
  selector: 'lum-phone',
  template: '<ng-content></ng-content>',
  styles: [],
})
/**
 * Note: <lum-phone> will be replaced with either a `<span>` or an `<a>` tag.
 */
export class PhoneComponent implements OnInit {
  @Input() number :string;

  numberInfo :PhoneNumber;

  constructor(
    private renderer :Renderer2,
    private elementRef :ElementRef,
  ) {}

  ngOnInit() :void {
    this.numberInfo = parsePhoneNumber(this.number, 'US');
    this.updateView();
  }

  /**
   * Replace the `<lum-phone>` element with either an `<a>` or a `<span>`
   */
  private updateView() {
    const element = this.elementRef.nativeElement;
    const parent = this.renderer.parentNode(element);

    const tag = this.numberInfo.isValid() ? 'a' : 'span';
    const newElement = this.renderer.createElement(tag);

    if (tag === 'a') {
      this.renderer.setAttribute(newElement, 'href', this.numberInfo.getURI());
    }

    // copy attributes
    Array.from((element as HTMLElement).attributes).forEach((attr) => {
      if (attr.name === 'number') {
        return;
      }

      this.renderer.setAttribute(newElement, attr.name, attr.value);
    });

    newElement.classList.add('lum-phone');

    if (element.hasChildNodes()) {
      // copy children
      Array.from(element.childNodes).forEach((child) => {
        this.renderer.appendChild(newElement, child);
      });
    } else {
      // set default content
      const defaultContent = this.renderer.createText(
        this.numberInfo.formatNational(),
      );

      this.renderer.appendChild(newElement, defaultContent);
    }

    // replace myself
    this.renderer.insertBefore(parent, newElement, element);
    this.renderer.removeChild(parent, element);
  }
}
